import { useEffect } from 'react';
import { FiX } from 'react-icons/fi';
import styles from './ImageLightbox.module.css';

// A photo shown full size over the page. Click anywhere outside the image or
// press Escape to close. Sits above Modal (z-index), so it can be opened from
// inside one — the listing detail modal stays open underneath.
const ImageLightbox = ({ src, alt = '', onClose }) => {
    useEffect(() => {
        const onKey = (event) => {
            if (event.key === 'Escape') onClose();
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [onClose]);

    return (
        <div className={styles.overlay} onClick={onClose} role="dialog" aria-modal="true" aria-label={alt || 'Image'}>
            <button type="button" className={styles.closeButton} aria-label="Close" onClick={onClose}>
                <FiX size={26} />
            </button>
            <img
                src={src}
                alt={alt}
                className={styles.image}
                onClick={(event) => event.stopPropagation()}
            />
        </div>
    );
};

export default ImageLightbox;
